/**
 * Abre o widget InBot (mesmo comportamento do botão AJUDA).
 * O launcher nativo (#bot_icon) é oculto via CSS; o clique o reabre.
 */
export function openSupportChat() {
  const click = () => document.getElementById("bot_icon")?.click();

  if (document.getElementById("bot_icon")) {
    click();
    return;
  }

  // Script do InBot pode ainda estar carregando (ex.: fluxo /lnc/).
  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (document.getElementById("bot_icon") || attempts >= 40) {
      window.clearInterval(timer);
      click();
    }
  }, 100);
}
